// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type HubspotPipelineQueryVariables = Types.Exact<{
  hubspotPipelineId: Types.Scalars['ID']['input'];
}>;

export type HubspotPipelineQuery = { __typename?: 'Query' } & {
  hubspotPipeline: Types.Maybe<{ __typename?: 'HubspotPipeline' } & Pick<Types.HubspotPipeline, 'id' | 'name'>>;
};

export const HubspotPipelineDocument = /*#__PURE__*/ gql`
    query HubspotPipeline($hubspotPipelineId: ID!) {
  hubspotPipeline(id: $hubspotPipelineId) {
    id
    name
  }
}
    `;

/**
 * __useHubspotPipelineQuery__
 *
 * To run a query within a React component, call `useHubspotPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubspotPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubspotPipelineQuery({
 *   variables: {
 *      hubspotPipelineId: // value for 'hubspotPipelineId'
 *   },
 * });
 */
export function useHubspotPipelineQuery(
  baseOptions: Apollo.QueryHookOptions<HubspotPipelineQuery, HubspotPipelineQueryVariables> &
    ({ variables: HubspotPipelineQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HubspotPipelineQuery, HubspotPipelineQueryVariables>(HubspotPipelineDocument, options);
}
export function useHubspotPipelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HubspotPipelineQuery, HubspotPipelineQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HubspotPipelineQuery, HubspotPipelineQueryVariables>(HubspotPipelineDocument, options);
}
// @ts-expect-error
export function useHubspotPipelineSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<HubspotPipelineQuery, HubspotPipelineQueryVariables>,
): Apollo.UseSuspenseQueryResult<HubspotPipelineQuery, HubspotPipelineQueryVariables>;
export function useHubspotPipelineSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HubspotPipelineQuery, HubspotPipelineQueryVariables>,
): Apollo.UseSuspenseQueryResult<HubspotPipelineQuery | undefined, HubspotPipelineQueryVariables>;
export function useHubspotPipelineSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HubspotPipelineQuery, HubspotPipelineQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HubspotPipelineQuery, HubspotPipelineQueryVariables>(HubspotPipelineDocument, options);
}
export type HubspotPipelineQueryHookResult = ReturnType<typeof useHubspotPipelineQuery>;
export type HubspotPipelineLazyQueryHookResult = ReturnType<typeof useHubspotPipelineLazyQuery>;
export type HubspotPipelineSuspenseQueryHookResult = ReturnType<typeof useHubspotPipelineSuspenseQuery>;
